
    __webpack_require__.initializeExposesData = {
  moduleMap: {
  "./App": () => {
return Promise.all(/*  | __federation_expose_App */ [__webpack_require__.e("395"), __webpack_require__.e("66"), __webpack_require__.e("981")]).then(() => (() => (__webpack_require__(3935))));
},
"./tile": () => {
return __webpack_require__.e(/*  | __federation_expose_tile */ "605").then(() => (() => (__webpack_require__(9144))));
},
},
  shareScope: "default",
};
__webpack_require__.getContainer = __webpack_require__.getContainer || function() { throw new Error("should have __webpack_require__.getContainer") };__webpack_require__.initContainer = __webpack_require__.initContainer || function() { throw new Error("should have __webpack_require__.initContainer") };
    __webpack_require__.initializeExposesData = {
  moduleMap: {
  "./App": () => {
return Promise.all(/*  | __federation_expose_App */ [__webpack_require__.e("395"), __webpack_require__.e("66"), __webpack_require__.e("981")]).then(() => (() => (__webpack_require__(3935))));
},
"./tile": () => {
return __webpack_require__.e(/*  | __federation_expose_tile */ "605").then(() => (() => (__webpack_require__(9144))));
},
},
  shareScope: "default",
};
__webpack_require__.getContainer = __webpack_require__.getContainer || function() { throw new Error("should have __webpack_require__.getContainer") };__webpack_require__.initContainer = __webpack_require__.initContainer || function() { throw new Error("should have __webpack_require__.initContainer") };